{
  "page": {
    "title": "Plan",
    "subtitle": "Choose a plan or add admin seats for your store.",
    "orderHistory": "Order history",
    "receiptRequired": "Enter your receipt details before paying.",
    "enterReceipt": "Enter receipt details",
    "receiptTitle": "Receipt details",
    "subscribeRenew": "Subscribe / renew plan",
    "addAdminSeats": "Add admin seats",
    "paidPlanRequired": "You need an active paid plan before you can add seats.",
    "renewalSeatsLocked": "Your current plan has {{count}} additional admin seats. The same quantity will renew with your plan. To add more, use the \"Add admin seats\" tab.",
    "bundlePrice": "Special price when purchased with a plan (normally {{price}}/month)",
    "proratedPrice": "Prorated for the time remaining on your current plan.",
    "payPromptPay": "Pay with PromptPay"
  },
  "planPicker": {
    "ariaLabel": "Plan",
    "oneMonth": "1 month",
    "perMonthRenew": "Per month · renew before expiry",
    "totalOnce": "{{total}} total, paid once per billing period"
  },
  "addon": {
    "title": "Add admin seats",
    "pricePerSeatMonth": "{{price}} per seat per month",
    "seatsAfter": "Total admin seats after purchase",
    "seatCount_one": "{{count}} seat",
    "seatCount_other": "{{count}} seats"
  },
  "summary": {
    "title": "Order summary",
    "basePlan": "Base plan",
    "pricePerSeat": "Price per seat",
    "perMonth": "{{price}} / month",
    "seatQuantity": "Number of seats",
    "daysRemaining": "Days remaining on plan",
    "dayCount_one": "{{count}} day",
    "dayCount_other": "{{count}} days",
    "addonSeats": "Additional seats",
    "renewExisting": "Renew {{count}} existing seats × {{price}} × {{days}} days",
    "newSeats": "{{count}} new seats × {{price}} × {{days}} days",
    "total": "Total",
    "renewPlan": "Renew plan",
    "from": "From",
    "to": "To",
    "starts": "Start date",
    "ends": "End date",
    "seatsAfterPayment_one": "You will have {{count}} admin seat after payment.",
    "seatsAfterPayment_other": "You will have {{count}} admin seats after payment."
  },
  "receiptForm": {
    "saved": "Receipt details saved.",
    "companyName": "Registered company name",
    "fullName": "Full name",
    "digits13": "Must be 13 digits",
    "taxIdRequired": "Enter the tax identification number",
    "individual": "Individual",
    "juristic": "Company",
    "nameRequired": "Enter a name",
    "taxId": "Tax identification number (13 digits)",
    "headOffice": "Head office",
    "branch": "Branch",
    "branchCode": "Branch code (5 digits)",
    "branchRequired": "Enter the branch code",
    "digits5": "Must be 5 digits",
    "address": "Receipt address",
    "addressRequired": "Enter an address",
    "zipCode": "Postal code",
    "zipRequired": "Enter the postal code",
    "email": "Receipt email",
    "emailRequired": "Enter an email address",
    "emailInvalid": "Enter a valid email address",
    "phone": "Phone number",
    "save": "Save receipt details"
  },
  "receiptCard": {
    "edit": "Edit",
    "taxIdShort": "Tax ID",
    "hint": "Used to issue receipts for plan payments. Changes apply to your next payment."
  },
  "history": {
    "title": "Order history",
    "backToPlan": "Back to plan",
    "kind": {
      "plan": "Plan",
      "planWithAddon": "Plan + additional seats",
      "addonOnly": "Additional seats"
    },
    "tabs": {
      "all": "All",
      "awaitingPayment": "Awaiting payment",
      "paid": "Paid",
      "expired": "Expired",
      "failed": "Failed",
      "cancelled": "Cancelled"
    },
    "empty": {
      "all": "No orders yet",
      "awaitingPayment": "No orders awaiting payment",
      "paid": "No paid orders yet",
      "expired": "No expired orders",
      "failed": "No failed orders",
      "cancelled": "No cancelled orders"
    },
    "cancelTitle": "Cancel this order?",
    "cancelWarning": "If you pay after cancelling, we will receive the payment but your plan will not renew. You will need to contact support for a refund.",
    "confirmCancel": "Confirm cancellation",
    "close": "Close",
    "cancelledSuccess": "Order cancelled.",
    "viewDetails": "View details",
    "continuePayment": "Continue payment",
    "cancelOrder": "Cancel order",
    "date": "Date",
    "type": "Type",
    "status": "Status",
    "amount": "Amount",
    "orderMenu": "Order menu"
  },
  "status": {
    "awaitingPayment": "Awaiting payment",
    "paid": "Paid",
    "expired": "Expired",
    "failed": "Failed",
    "cancelled": "Cancelled"
  },
  "payment": {
    "notFound": "Order not found",
    "notFoundDetail": "This order may have been deleted, or you may not have permission to view it.",
    "orderExpired": "Order expired",
    "paymentFailed": "Payment failed",
    "orderCancelled": "Order cancelled",
    "startNew": "Please start a new order.",
    "title": "Pay with PromptPay",
    "subtitle": "Scan the QR code below with your banking app to pay.",
    "instructionsTitle": "How to pay",
    "instruction1": "Open your bank or mobile banking app.",
    "instruction2": "Choose Scan QR (PromptPay).",
    "instruction3": "Scan the QR code above.",
    "instruction4": "Check the amount and confirm payment.",
    "instruction5": "The order status updates automatically after payment.",
    "qrMissing": "QR code unavailable",
    "qrAltWithAmount": "PromptPay payment QR code for {{amount}}",
    "qrAlt": "PromptPay payment QR code",
    "qrExpired": "This QR code has expired — please start a new order.",
    "qrExpiresIn": "QR code expires in {{duration}}"
  },
  "success": {
    "title": "Payment successful",
    "activeUntil": "Your plan is active until {{date}}.",
    "updating": "We are updating your plan status.",
    "goToChat": "Go to dashboard",
    "viewHistory": "View order history"
  },
  "detail": {
    "title": "Order details",
    "type": "Type:",
    "monthCount_one": "{{count}} month",
    "monthCount_other": "{{count}} months",
    "seatCount_one": "+{{count}} seat",
    "seatCount_other": "+{{count}} seats",
    "paidAfterCancel": "Payment received after cancellation",
    "paidAfterCancelDetail": "This order was cancelled, but we received its payment.",
    "contactRefund": "Contact us on LINE for a refund",
    "timeline": "Timeline",
    "createdAt": "Created",
    "paidAt": "Paid",
    "expiredAt": "Expired",
    "cancelledAt": "Cancelled",
    "downloadReceipt": "Download receipt",
    "receiptFailed": "Could not issue receipt",
    "receiptFailedDetail": "We could not issue the receipt automatically. Please contact support so we can investigate.",
    "receiptPending": "Issuing receipt",
    "discount": "Discount",
    "regularPrice": "Regular price ({{price}} × {{count}} months)",
    "discountPercent": "{{percent}}% discount",
    "actualPaid": "Amount paid"
  },
  "renew": {
    "expired": "Plan expired —",
    "buy": "buy a plan",
    "continue": "to continue"
  },
  "failure": {
    "insufficientFunds": "Insufficient funds",
    "expired": "The QR code expired before payment",
    "cancelled": "The payment was cancelled",
    "declined": "The bank declined the payment",
    "riskDeclined": "The bank declined the payment for security reasons",
    "timeout": "The transaction took too long",
    "unknown": "Payment failed · contact LINE OA {{lineId}}"
  },
  "errors": {
    "subscriptionExpiredTitle": "Plan expired",
    "subscriptionExpired": "Subscribe to keep using Sight Order.",
    "subscribe": "Subscribe",
    "addonDecrease": "Additional seats cannot be reduced during renewal. Keep the current quantity or add more.",
    "cartChanged": "Your cart changed. Please try again.",
    "pendingTitle": "Order awaiting payment",
    "pendingDetail": "Pay or cancel your pending order before creating another one.",
    "viewOrders": "View orders",
    "persistTitle": "Could not save the order",
    "persistDetail": "Our team has been notified. Please do not pay twice · contact LINE OA {{lineId}}",
    "acknowledge": "Got it",
    "addonRequiresPlan": "You need an active paid plan before purchasing additional seats.",
    "provider": "The payment service is unavailable. Please try again later.",
    "invalidTotal": "The order total is invalid.",
    "loadPlans": "Could not load plans.",
    "calculatePrice": "Could not calculate the price.",
    "connectServer": "Could not connect to the server.",
    "loadOrder": "Could not load the order.",
    "cancelOrder": "Could not cancel the order.",
    "downloadReceipt": "Could not download the receipt.",
    "loadReceipt": "Could not load receipt details.",
    "saveReceipt": "Could not save receipt details."
  }
}
